import React, { useState, useEffect } from "react";
// import toast from 'react-hot-toast';
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import DataTable from "react-data-table-component";
import Moment from "react-moment";

//Redux
import { useSelector, useDispatch } from "react-redux"; //useDispatch
//Serivce
//Components
import Layout from "../../../../../Layout/Layout";
import Constants from "../../../../../common/SupplierConstants";
import { useNavigate } from "react-router-dom";

import ShowStatus from "../../../../../Components/Modal/supplier_app/Workflow/ShowStatus";
import configFromEnv from "../../../../../services/configuration";
import {
  formatDate,
} from "../../../../../common/Validations";
import { SearchField } from "../../../../../Components/formElements/SearchField";
import CancelModal from "../../../../../Components/Modal/supplier_app/common/CancelModal";
import InventoryConstants from "../../../../../common/InventoryConstants";
import { addProNr, getWhOrderList } from "../../../../../redux/feature/inventory_app/inventorySlice";
import CommonItemLevelDatatableModal from "../../../../../Components/Modal/supplier_app/CommonItemLevelDatatableModal";

const OrderList = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // localStorage.setItem("menu", "Production");
  // localStorage.setItem("submenu", "Production Order");

  let proData = useSelector((state) => state?.inventory?.productionOrder); // User Details from Store
  let poDocDataTable = useSelector(
    (state) => state?.customer?.purchaseOrder?.pagination
  ); // User Details from Store


  const [data, setData] = useState([]);
  const [getNewPerPage, setNewPerPage] = useState(10);
  const [isCardVisible, setCardVisible] = useState(true);
  const [getCommonSearchTxt, setCommonSearchTxt] = useState("");

  // Show Status Modal
  const [modalShowStatus, setModalShowStatus] = useState(false);
  const [sendDataModal /*setSendDataModal*/] = useState("");
  const [modelTitle /*setModelTitle*/] = useState("");

  const [getItemLevelData, setItemLevelData] = useState([]);
  const [getItemLevelColumns, setItemLevelColumns] = useState([]);
  const [getModalTitle, setModalTitle] = useState("");
  const [itemLevelModalShow, setItemLevelModalShow] = useState(false);

  const toggleCardVisibility = () => {
    setCardVisible(!isCardVisible);
  };

  // OnClick on lineItem  Data
  const lineItemShowModal = (itemLevelData) => {
    setItemLevelData(itemLevelData);
    setItemLevelColumns(bomItems);
    setModalTitle("Line Item Details");
    setItemLevelModalShow(true);
  };
  const lineItemShowModalByProducts = (itemLevelData) => {
    setItemLevelData(itemLevelData);
    setItemLevelColumns(byProductsItems);
    setModalTitle("Line Item Details");
    setItemLevelModalShow(true);
  };
  const itemLevelHideModal = () => {
    setItemLevelModalShow(false);
  };

  /* Modal Function */
  const createWarehouseOrder = () => {
    // setModalShow(true);
    navigate(InventoryConstants.INVENTORY_ORDER_CREATION);
  };
  const detailedPage = (proNrr) => {
    dispatch(addProNr(proNrr));
    navigate(InventoryConstants.INVENTORY_PRODUCTION_ORDER_DETAILS);
  };
  //on page load
  const hideModalStatus = () => {
    setModalShowStatus(false);
  };

  const columns = [

    {
      name: "Document Nr",
      cell: (row) => (
        <button
          className="btnInfo"
          onClick={() => detailedPage(row.productionOrderNr)}
        >
          {row.productionOrderNr}{" "}
        </button>
      ),
      width: "150px",
    },
    {
      name: "Material",
      selector: (row) => row.FG_Mat_Desc || "--",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1">{row.FG_Mat_Desc} </p>
        </div>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Bom",
      cell: (item) => (
        <>
          <span
            style={{ marginLeft: "12px" }}
            onClick={() => lineItemShowModal(item.bom)}
          >
            <i className="bi bi-calendar2-week iconTable"></i>
          </span>
          <span className="suppliersIcon"> {item.bom?.length} </span>
        </>
      ),
      width: "120px",
    },
    {
      name: "By Products",
      cell: (item) => (
        <>
          <span
            style={{ marginLeft: "12px" }}
            onClick={() => lineItemShowModalByProducts(item.byProducts)}
          >
            <i className="bi bi-calendar2-week iconTable"></i>
          </span>
          <span className="suppliersIcon"> {item.bom?.length} </span>
        </>
      ),
      width: "120px",
    },
    {
      name: "Quantity",
      cell: (row) => (
        <>
          <span className="m-0 p-0 pt-1 fw-bold">{row.Quantity}</span>
        </>
      ),
      selector: (row) => row.Quantity || "--",
      sortable: true,
      width: "110px",
    },
    {
      name: "Plant",
      selector: (row) => row.Plant_Code,
      sortable: true,
      width: "110px",
      cell: (row) => (
        <div>
          <p className="">{row.Plant_Code} </p>
        </div>
      ),
    },
    {
      name: "Created Date",
      selector: (row) => formatDate(row.createdAt),
      cell: (row) => (
        <Moment format={configFromEnv.TIME_FORMATE_WITH_TIME}>
          {row.createdAt}
        </Moment>
      ),
      sortable: true,
      width: "160px",
    },
  ];
  const bomItems = [
    {
      name: "Material Name",

      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold">{row.Component_Desc} </p>
        </div>
      ),
      width: "180px",
    },
    {
      name: "Quantity",
      cell: (row) => <span>{row.Quantity} </span>,
      width: "220px",
    },
    {
      name: "UOM",
      cell: (row) => <span>{row.UOM} </span>,
      width: "220px",
    },
    {
      name: "Cal Qty",
      cell: (row) => <span>{row.Quantity} </span>,
      width: "220px",
    },
    {
      name: "Actual Qty",
      cell: (row) => <span>{row.Quantity} </span>,
      width: "220px",
    },

  ];

  const byProductsItems = [
    {
      name: "Material Name",

      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold">{row.Component_Desc} </p>
        </div>
      ),
      width: "180px",
    },
    {
      name: "Batch",
      cell: (row) => <span>{row.Component_Code} </span>,
      width: "220px",
    },
    {
      name: "Quantity",
      cell: (row) => <span>{row.Quantity} </span>,
      width: "220px",
    },
    {
      name: "Cal Qty",
      cell: (row) => <span>{row.Quantity} </span>,
      width: "220px",
    },
    {
      name: "Actual Qty",
      cell: (row) => <span>{row.Quantity} </span>,
      width: "220px",
    },

  ];
  const loadInitialPoData = async () => {
    setData(proData?.data);
  };

  const handlePageChange = (page) => {
    let obj = {
      ueryName: "",
      module: "PRODUCTOIN_ORDER",
      page: page,
      per_page: getNewPerPage,
    };

    dispatch(getWhOrderList(obj));
    setData(proData?.data);
  };

  const handlePerRowsChange = async (newPerPage, page) => {
    let obj = {
      queryName: "",
      module: "PRODUCTOIN_ORDER",
      page: page,
      per_page: newPerPage,
    };
    setNewPerPage(newPerPage);
    dispatch(getWhOrderList(obj));
    setData(proData?.data);
  };

  // Common Search Function on button
  const handleSearchFuncApi = async () => {
    let obj = {
      queryName: "",
      module: "PRODUCTOIN_ORDER",
      page: 1,
      per_page: 10,
      searchTerm: getCommonSearchTxt,
    };
    dispatch(getWhOrderList(obj));
  };

  //on page load
  useEffect(() => {
    let obj = {
      queryName: "",
      module: "PRODUCTOIN_ORDER",
      page: 1,
      per_page: 10,
    };
    dispatch(getWhOrderList(obj));

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    loadInitialPoData(); // fetch page 1 of users
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [proData]);

  /* Cancel Modal */
  const [getCancelModalStatus, setCancelModalStatus] = useState(false);
  const cancelModalHide = () => {
    setCancelModalStatus(false);
  };

  /* Handle selected rows */
  const [getSelectedRows, setSelectedRows] = useState([]);
  const handleRowSelected = ({ selectedRows }) => {
    const validRows = selectedRows.filter(
      (item) => item?.statusHeader !== "Cancelled"
    );
    setSelectedRows(validRows);
  };

  return (
    <main className="dashboard main" id="main">
      <Layout />
      <Row className="justify-center subContent">
        <Col xs={12} md={12} className="rightSide">
          <div className="rightSideInner PageCommonCSS">
            <Row>
              <Col xs={12} md={9} lg={9}>
                <h2 className="mainTitle">Warehouse order</h2>
                <p className="subText">Lists of Warehouse order and details</p>
              </Col>
              <Col xs={12} md={3} lg={3} className="mt-3">
                <SearchField
                  name="searchKey"
                  value={getCommonSearchTxt}
                  onChange={(event) => setCommonSearchTxt(event.target.value)}
                  onClick={() => handleSearchFuncApi()}
                />
              </Col>
            </Row>
            <hr />
            <div className="accordion" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${isCardVisible ? "bi-chevron-right" : "bi-chevron-down"
                          }`}
                        onClick={toggleCardVisibility}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">WL</span>
                    </Col>
                    <Col xs={6} md={4} lg={4}>
                      <span className="headerTitle">WO List</span>
                      <span className="subHeaderTitle">
                        View of WO and Status{" "}
                      </span>
                    </Col>

                    <Col xs={12} md={8} lg={8} className="headerButtonAlign">
                      {/* {config?.createManualPOBtn && ( */}
                      <Col xs={3} md={3} lg={3} className="">
                        <button
                          className="btnTable"
                          onClick={() => createWarehouseOrder()}
                        >
                          Create Warehouse Order
                        </button>
                      </Col>
                    </Col>
                  </Row>
                </h2>
                <div
                  className={`accordion-collapse collapse show ${isCardVisible ? "visible" : ""
                    }`}
                >
                  <div className="accordion-body">
                    <Row>
                      <Col xs={12} md={12} lg={12}>
                        <DataTable
                          title=""
                          columns={columns}
                          data={data}
                          progressPending={proData?.status}
                          paginationRowsPerPageOptions={Constants.ROW_PER_PAGE}
                          pagination
                          paginationServer
                          paginationTotalRows={poDocDataTable.total}
                          onChangeRowsPerPage={handlePerRowsChange}
                          onChangePage={handlePageChange}
                          onSelectedRowsChange={handleRowSelected}
                          selectableRows
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Col>
      </Row>
      <ShowStatus
        show={modalShowStatus}
        onHide={() => hideModalStatus()}
        rowdatamodal={sendDataModal}
        modeltitle={modelTitle}
      />
      <CancelModal
        title="Cancel the Purchase Order"
        type={module}
        show={getCancelModalStatus}
        onHide={cancelModalHide}
        selectedrow={getSelectedRows}
      />
      <CommonItemLevelDatatableModal
        show={itemLevelModalShow}
        onHide={() => itemLevelHideModal()}
        columns={getItemLevelColumns}
        data={getItemLevelData}
        title={getModalTitle}
      />
    </main>
  );
};
export default OrderList;
